export function easeOutElastic(time, startIntensity = 2, elasticPeriod = 0.5) {
  if (time === 0 || time === 1) {
    return time;
  }
  const modifiedTime = Math.pow(time, startIntensity);
  const amplitudeAdjustment = elasticPeriod / (2 * Math.PI) * Math.asin(1);
  return Math.pow(2, -10 * modifiedTime) * Math.sin(
    (modifiedTime - amplitudeAdjustment) * (2 * Math.PI) / elasticPeriod
  ) + 1;
}
export function easeOutSine(x) {
  return Math.sin(x * Math.PI / 2);
}
export function easeOutQuad(x) {
  return 1 - (1 - x) * (1 - x);
}
